import { render, staticRenderFns } from "./UserWallets.vue?vue&type=template&id=2f6505ac&"
import script from "./UserWallets.vue?vue&type=script&lang=js&"
export * from "./UserWallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports